/* import __COLOCATED_TEMPLATE__ from './footer.hbs.js'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();